import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react';

import { ContractPartTimeSplitType, ContractPartTimeSplitTypes, ContractTypeModel } from '@app/Models';
import { EnumHelpers } from '@app/Services/EnumHelpers';

type ChangeBlockLengthHandler = (value: number) => void;
type ChangeSplitTypeHandler = (type: ContractPartTimeSplitType) => void;

type ContractPartTimeVariableDayBlockProps = {
    onChangeBlockLength: ChangeBlockLengthHandler;
    onChangeSplitType: ChangeSplitTypeHandler;
    blockLength?: number;
    blockSplitType?: ContractPartTimeSplitType;
    className?: string;
    disabled?: boolean;
    typeModel: ContractTypeModel;
};

@observer
export class ContractPartTimeVariableDayBlock extends React.Component<ContractPartTimeVariableDayBlockProps, {}> {
    private _store: ContractPartTimeVariableDayBlockStore;

    constructor(props: ContractPartTimeVariableDayBlockProps) {
        super(props);
        this._store = new ContractPartTimeVariableDayBlockStore(props);
    }

    render() {
        return (
            <>
                <Dropdown
                    label="Block Length"
                    options={this.props.typeModel === ContractTypeModel.TZV_VariableDay ? this._store.variableDayBlockLengthOptions : this._store.variableDayLhSffBlockLengthOptions}
                    onChange={this._store.onChangeBlockLength}
                    required={true}
                    selectedKey={this.props.blockLength}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
                <Dropdown
                    label="Split Type"
                    options={this._store.contractSplitTypeOptions}
                    onChange={this._store.onChangeSplitType}
                    required={true}
                    selectedKey={this.props.blockSplitType as string}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
            </>
        );
    }
}

class ContractPartTimeVariableDayBlockStore {
    private readonly _onChangeBlockLengthFunction: ChangeBlockLengthHandler;
    private readonly _onChangeSplitTypeFunction: ChangeSplitTypeHandler;
    @observable blockPerYear?: number;

    constructor(props: ContractPartTimeVariableDayBlockProps) {
        this._onChangeBlockLengthFunction = props.onChangeBlockLength;
        this._onChangeSplitTypeFunction = props.onChangeSplitType;
    }

    onChangeBlockLength = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeBlockLengthFunction(option.key as number);
        }
    };

    onChangeSplitType = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeSplitTypeFunction(option.key as ContractPartTimeSplitType);
        }
    };

    get variableDayBlockLengthOptions() {
        let keys = [];
        for (let i = 1; i < 15; i++) {
            keys.push({ key: i, text: i.toString() });
        }
        return keys;
    }

    get variableDayLhSffBlockLengthOptions() {
        let keys = [];
        for (let i = 1; i < 4; i++) {
            keys.push({ key: i, text: i.toString() });
        }
        return keys;
    }

    get contractSplitTypeOptions() {
        return EnumHelpers.toKeyValueArray(ContractPartTimeSplitTypes);
    }
}